module.exports = __webpack_public_path__ + "static/media/enlace2.68242778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/enlace2.svg
// module id = 353
// module chunks = 0